import * as Yup from "yup";
import { registrationDobSchema } from "../../../Register/Register.validator";

const buildInsuranceInformationSchema = (requireHolderFields) =>
  Yup.object().shape({
    provider: Yup.string()
      .trim()
      .required("NUTRITION_INSMANUAL_VAL_SELECT_PROVIDER"),
    memberId: Yup.string().trim().required("NUTRITION_INSMANUAL_VAL_MEMBER_ID"),
    relationship: Yup.string()
      .trim()
      .required("NUTRITION_INSMANUAL_VAL_RELATIONSHIP"),
    groupNumber: Yup.string().trim().nullable(),
    holderFirstName: requireHolderFields
      ? Yup.string()
          .trim()
          .required("NUTRITION_INSMANUAL_VAL_HOLDER_FIRST_NAME")
      : Yup.string().trim().nullable(),
    holderLastName: requireHolderFields
      ? Yup.string()
          .trim()
          .required("NUTRITION_INSMANUAL_VAL_HOLDER_LAST_NAME")
      : Yup.string().trim().nullable(),
    holderDob: requireHolderFields
      ? registrationDobSchema("NUTRITION_INSMANUAL_VAL_HOLDER_DOB")
      : Yup.string().trim().nullable(),
  });

export const getInsuranceHolderDobValidationError = (
  holderDob,
  shouldValidate = true
) => {
  if (!shouldValidate) {
    return null;
  }
  try {
    registrationDobSchema("NUTRITION_INSMANUAL_VAL_HOLDER_DOB").validateSync(
      holderDob
    );
    return null;
  } catch (error) {
    return error?.message || null;
  }
};

export const getInsuranceInformationValidationError = (
  form,
  requireHolderFields = false
) => {
  try {
    buildInsuranceInformationSchema(requireHolderFields).validateSync(form, {
      abortEarly: true,
    });
    return null;
  } catch (error) {
    return error?.message || null;
  }
};

export const isInsuranceInformationFormComplete = (
  form,
  requireHolderFields = false
) => getInsuranceInformationValidationError(form, requireHolderFields) === null;
